import styled from 'styled-components';

export const UiInlineSelect = styled.div`
	display: block;
`;